import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  width: 100%;
  max-width: 1440px;
`;

export const PanelHeader = styled.div`
  width: 100%;

  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[300]};
  border-radius: 16px;
  padding: 20px 24px;

  .head-title {
    display: flex;
    align-items: center;
    gap: 8px;

    span.title {
      font-size: 22px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.heading};
    }
  }

  .head-sub {
    margin-top: 4px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.muted};
  }
`;

export const PanelBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Badge = styled.span`
  background: ${({ theme }) => theme.colors.primary[70]};
  color: ${({ theme }) => theme.colors.orange.dark};
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  padding: 2px 8px;
  border-radius: 999px;
  text-transform: uppercase;
`;

export const Cards = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr);
  gap: 24px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[300]};
  border-radius: 16px;
  padding: 24px;
`;

export const Tabs = styled.div`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray[300]};
  margin-bottom: 24px;
`;

export const Tab = styled.button<{ $active: boolean }>`
  flex: 1;
  background: none;
  border: none;
  padding: 12px 0;
  cursor: pointer;
  font-size: 15px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.heading : theme.colors.muted};
  border-bottom: 2px solid
    ${({ theme, $active }) =>
      $active ? theme.colors.orange.primary : 'transparent'};
  margin-bottom: -1px;
  transition: color 0.2s, border-color 0.2s;
`;

export const Field = styled.div`
  & + & {
    margin-top: 20px;
  }

  label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.heading};
    margin-bottom: 8px;
  }
`;

export const Hint = styled.p`
  margin-top: 8px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.muted};
`;

export const InfoNote = styled.div`
  margin-top: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${({ theme }) => theme.colors.primary[80]};
  border-radius: 8px;
  padding: 14px 16px;

  font-size: 13px;
  color: ${({ theme }) => theme.colors.neutralDark[50]};

  svg {
    flex-shrink: 0;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.orange.primary};
  }
`;

// larguras fixas nas colunas de valor p/ o cabecalho e as linhas alinharem
// (sao grids separados). 1fr no rotulo, colunas de valor identicas nos dois.
const resultGrid = `
  display: grid;
  grid-template-columns: 1fr 116px 116px;
  gap: 12px;
  align-items: center;

  @media (max-width: 400px) {
    grid-template-columns: 1fr 92px 92px;
    gap: 8px;
  }
`;

export const ResultsHead = styled.div`
  ${resultGrid}
  align-items: end;
  padding-bottom: 8px;

  span {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.3;
    text-align: right;
    color: ${({ theme }) => theme.colors.heading};
  }

  small {
    font-size: 11px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.muted};
  }
`;

export const ResultRow = styled.div`
  ${resultGrid}
  padding: 14px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.gray[300]};

  .info {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.heading};

    svg {
      font-size: 16px;
      color: ${({ theme }) => theme.colors.orange.primary};
    }
  }

  .desc {
    font-size: 12px;
    line-height: 1.4;
    color: ${({ theme }) => theme.colors.muted};
  }

  strong {
    font-size: 15px;
    font-weight: 600;
    text-align: right;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.heading};
  }

  strong.repassa {
    color: ${({ theme }) => theme.colors.orange.primary};
  }
`;

export const Disclaimer = styled.div`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.gray[300]};
  display: flex;
  align-items: center;
  gap: 8px;

  font-size: 12px;
  color: ${({ theme }) => theme.colors.muted};

  svg {
    flex-shrink: 0;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.orange.primary};
  }
`;

export const Transparencia = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[300]};
  border-radius: 16px;
  padding: 20px 24px;

  display: flex;
  align-items: center;
  gap: 16px;

  .icon {
    flex-shrink: 0;
    height: 44px;
    width: 44px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.colors.primary[80]};
    color: ${({ theme }) => theme.colors.orange.primary};
    font-size: 22px;
  }

  .texts {
    flex: 1;

    h4 {
      font-size: 15px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.heading};
    }

    p {
      margin-top: 2px;
      font-size: 13px;
      color: ${({ theme }) => theme.colors.muted};
    }
  }

  .saibaMais {
    display: flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: none;
    cursor: pointer;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.orange.primary};
  }

  @media (max-width: 600px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
    padding: 16px;

    .texts {
      width: 100%;
      min-width: 0;

      h4,
      p {
        overflow-wrap: anywhere;
      }
    }

    .saibaMais {
      max-width: 100%;
      white-space: normal;
      text-align: left;
    }
  }
`;
